import React, { FC } from 'react';
import styled from 'styled-components';

import InfoElement, { InfoElementProperties } from 'components/common/Card/common/InfoElement/InfoElement';

const InformationContainer = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 15px;
`;

export type InfoElementType = InfoElementProperties;

interface InfoElementsProps {
    infoElements: InfoElementProperties[];
}

const InfoElements: FC<InfoElementsProps> = ({ infoElements }) => {
    return (
        <InformationContainer role="list">
            {infoElements.map((element, index) => <InfoElement
                key={`${element.elementKey}-${index}`}
                {...element}>
            </InfoElement>)}
        </InformationContainer>
    );
};

export default InfoElements;
